<template>
  <div class="container container-table">
    <div class="row vertical-10p">
      <div class="container">
        <div class="login-box box">
          <div class="login-logo">
            <router-link to="/">
              <img class="img-responsive center-block" width="75%" height="auto" src="static/img/logo-lg.svg" alt="logo">
            </router-link>
          </div>
          <div class="login-box-body">
            <template v-if="!isLocal">
              <p class="login-box-msg">
                Bitte melden Sie sich hier auf Qualibet an.
              </p>
              <button class="btn btn-success btn-block" @click.prevent="oktaRedirectLink">Jetzt anmelden</button>
            </template>
            <template v-else>
              <p class="login-box-msg">
                Bitte tragen Sie Ihren generierten Token ein.
              </p>
              <div class="form-group">
                <textarea
                  v-validate="'required'"
                  data-vv-as="Token"
                  class="form-control"
                  name="token"
                  :placeholder="'token' | translate"
                  type="text"
                  rows="12"
                  v-model="token"
                >
                </textarea>
                <span v-show="errors.has('token')" class="small text-danger">{{ 'valid_token_is_required' | translate }}</span>
              </div>
              <button :disabled="!token" class="btn btn-success btn-block" @click.prevent="localLogin">{{ 'local_login' | translate }}</button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OktaLogin',
  data () {
    return {
      uri: '',
      client_id: '',
      isLocal: false,
      token: '',
      isValid: false
    }
  },
  mounted() {
    this.checkLoggedIn()
    this.isLocalToggle()
  },
  methods: {
    checkLoggedIn() {
      if (this.$store.getters.loggedInStatus) {
        this.$router.push('/home')
      }
    },
    isLocalToggle() {
      if (window.location.hostname === 'localhost' || window.location.hostname === 'qualibet.local' || window.location.hostname === 'cs-frontend.test') {
        this.isLocal = true
      }
    },
    oktaRedirectLink () {
      let productionURLs = ['cs.qb-schuhe.de']
      if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
        this.uri = 'https://cs.qb-schuhe.de/redirect'
        this.client_id = '0oa4g4msr3RIVXmyQ417'
      } else if (window.location.hostname === 'cs.staging-qb.de') {
        this.uri = 'https://cs.staging-qb.de/redirect'
        this.client_id = '0oa42vsjqpVWsYxlS417'
      }
      window.location.href = `https://login.anwr-group.com/oauth2/v1/authorize?client_id=${this.client_id}&response_type=code&response_mode=query&scope=openid+email+profile&redirect_uri=${this.uri}&state=ApplicationState`
    },
    isValidJWTToken(token) {
      try {
        JSON.parse(atob(token.split('.')[1])).data;
      } catch (e) {
        return false;
      }
      return true;
    },
    localLogin () {
      if (this.isValidJWTToken(this.token)) {
        let tokenData = JSON.parse(atob(this.token.split('.')[1])).data
        this.$store.commit('updateUser', {
          "username": tokenData.username,
          "first_name": tokenData.full_name.split(' ')[0],
          "last_name": tokenData.full_name.split(' ')[1],
          "email": "",
          "company": "",
          "token": this.token,
          "roles": tokenData.roles
        })
        this.$store.commit('updateRoles', tokenData.roles)
        this.$store.commit('updateToken', this.token)
        this.$store.commit('updateLoggedInStatus', true)
        API.all([
          API.get(`orders/orderFilters`),
          API.get(`salesChannels`)
        ]).then(API.spread((response, channels) => {
          this.$store.commit('updateOrderStatusFilters', response.data.status)
          this.$store.commit('updateOrderPaymentsFilters', response.data.payments)
          this.$store.commit('updateOrderChannelsFilters', response.data.channels)
          this.$store.commit('updateSalesChannels', channels.data)
          this.$store.commit('updateOrderCountries', response.data.countries)
          this.$router.push('/home')
        }))
      } else {
        this.token = ''
      }
    }
  }
}
</script>

<style></style>
<style scoped>
  textarea
  {
    resize: none;
  }
</style>





// WEBPACK FOOTER //
// src/components/views/OktaLogin.vue